export const REQUEST_STARRED = 'REQUEST_STARRED';
export const SUCCESS_STARRED = 'SUCCESS_STARRED';
export const FAILURE_STARRED = 'FAILURE_STARRED';
export const CLEAR_STARRED = 'CLEAR_STARRED';
